import { Handle, NodeProps, Position } from 'reactflow'
import ExternalAppsImage from './external-apps.png'
import NavLink from 'ui-kit/actions/link/NavLink'
import { LINKS } from 'routes/constants'
import { MinimalConnector } from 'routes/Scenarios/helpers/types'
import classes from './nodeStyles.module.scss'

export const EXTERNAL_APPS_NODE_WIDTH = 60
export const EXTERNAL_APPS_NODE_TEXT_LABEL_HEIGHT = 46

const PLACEHOLDER_IMAGE_HEIGHT = 317
const APP_LIST_PADDING = 8
const BORDER_SIZE = 1
const INTEGRATION_ICON_SIZE = 42
const GAP_BETWEEN_ICONS = 13

export function calculateExternalAppsNodeHeight(numberOfConnectors: number) {
  const textAndContainerHeight =
    EXTERNAL_APPS_NODE_TEXT_LABEL_HEIGHT +
    APP_LIST_PADDING * 2 +
    BORDER_SIZE * 2

  if (numberOfConnectors === 0) {
    return textAndContainerHeight + PLACEHOLDER_IMAGE_HEIGHT
  }

  return (
    textAndContainerHeight +
    GAP_BETWEEN_ICONS * (numberOfConnectors - 1) +
    INTEGRATION_ICON_SIZE * numberOfConnectors
  )
}

export function ExternalAppsNode(
  props: NodeProps<{ connectors: MinimalConnector[] }>,
) {
  const connectors = props.data?.connectors ?? []

  const height = calculateExternalAppsNodeHeight(connectors.length)

  return (
    <div
      style={{
        width: EXTERNAL_APPS_NODE_WIDTH,
        height,
      }}
      className={classes.externalApps}
    >
      <div
        style={{ height: EXTERNAL_APPS_NODE_TEXT_LABEL_HEIGHT }}
        className={classes.externalApps_header}
      >
        External Apps
      </div>

      <ul
        className={classes.externalApps_list}
        style={{
          padding: APP_LIST_PADDING,
          gap: GAP_BETWEEN_ICONS,
        }}
      >
        {connectors.length > 0 ? (
          <>
            {connectors.map((connector) => (
              <li key={connector.key} className={classes.externalApps_item}>
                <NavLink
                  className={classes.externalApps_link}
                  href={`${LINKS.INTEGRATIONS}/${connector.key}`}
                >
                  <img
                    style={{
                      width: INTEGRATION_ICON_SIZE,
                      height: INTEGRATION_ICON_SIZE,
                    }}
                    className={classes.externalApps_connector}
                    src={connector?.logoUri}
                    alt={connector.name}
                  />
                </NavLink>
              </li>
            ))}
          </>
        ) : (
          <img src={ExternalAppsImage.src} alt='External apps' />
        )}
      </ul>
      <Handle
        type='source'
        position={Position.Left}
        className='opacity-0'
        style={{
          top: height / 2 + EXTERNAL_APPS_NODE_TEXT_LABEL_HEIGHT / 2, // the default value is 50% (height / 2), but we want to offset for the test at the top
        }}
      />
    </div>
  )
}
